import { AsapCrudModule, Global } from 'asap-crud';
import { NgModule } from '@angular/core';
import { AsapUploadComponent } from './asap-upload.component';
import { ModalUploadPluginComponent } from './modal-upload/modal-upload.component';
import { ModalMultiuploadPluginComponent } from './modal-multi-upload/modal-multi-upload.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ImageCropperModule } from 'ngx-img-cropper';
import { BlockUIModule } from 'ng-block-ui';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatSnackBarModule,
    ImageCropperModule,
    AsapCrudModule,
    TranslateModule,
    BlockUIModule.forRoot()  
  ],
  declarations: [
    AsapUploadComponent,
    ModalUploadPluginComponent,
    ModalMultiuploadPluginComponent
  ],
  exports: [
    AsapUploadComponent,
    ModalUploadPluginComponent,
    ModalMultiuploadPluginComponent
  ],
  entryComponents: [ 
    ModalUploadPluginComponent,
    ModalMultiuploadPluginComponent
  ],
  providers: [
  ]
})

export class AsapUploadModule { 

  constructor(
    public dialog: MatDialog,
    public global: Global
  ) {
    let asapUpload = this.global.getSessionData('asap-upload');
    if (!asapUpload) {
      asapUpload = new AsapUploadComponent(dialog);
      console.log("[AsapUploadModule] global", this.global);
      console.log("[AsapUploadModule] AsapUpload", asapUpload);
      if (asapUpload && this.global) {
        this.global.setSessionData('asap-upload',asapUpload);
      }
    }
  }

}
